import NameWithEmoji from 'src/components/name_with_emoji/name_with_emoji.vue'
import UnicodeDomainIndicator from 'src/components/unicode_domain_indicator/unicode_domain_indicator.vue'
import UserAvatar from 'src/components/user_avatar/user_avatar.vue'

import {
  displayName,
  profileLink,
} from 'src/services/user_display/user_display.js'

const UserListRow = {
  name: 'UserListRow',
  components: { NameWithEmoji, UnicodeDomainIndicator, UserAvatar },
  props: {
    user: { type: Object, required: true },
  },
  methods: { displayName, profileLink },
}

export default UserListRow
